import * as React from 'react';
import { IPhotoInlineGrid } from './interfaces';
import InfoIcon from '@mui/icons-material/Info';
import {
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from '@mui/material';
import { formatLocaleDate } from '@helpers/dateHelpers';

export const PhotoInlineGrid: React.FC<IPhotoInlineGrid> = ({
  photos,
}): JSX.Element => {
  return (
    <ImageList
      variant="masonry"
      cols={4}
      sx={{
        m: 0,
      }}
    >
      {photos.map((photo) => (
        <ImageListItem
          key={photo.src}
          sx={{
            position: 'relative',
            '&:hover .MuiImageListItemBar-root': {
              opacity: 1,
            },
          }}
        >
          <img
            srcSet={`${photo.src}?w=248&fit=crop&auto=format&dpr=2 2x`}
            src={`${photo.src}?w=248&fit=crop&auto=format`}
            alt={photo.title}
            loading="lazy"
          />
          <ImageListItemBar
            title={photo.title}
            subtitle={formatLocaleDate(new Date(), false)}
            actionIcon={
              <IconButton
                sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                aria-label={`info about ${photo.title}`}
              >
                <InfoIcon />
              </IconButton>
            }
            sx={{
              opacity: 0,
              transition: 'opacity 0.3s',
            }}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
};
